module.exports = __webpack_public_path__ + "static/img/service_introduce_5117_zh_h5.bd72221.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_5117_zh_h5.png
// module id = ao2F
// module chunks = 34